import React, { Component , useEffect } from 'react';
import { SignIn, SignUp, ForgotPassword, Greetings, Authenticator } from 'aws-amplify-react'
import * as CustomSwitch from './switch';
import * as CustomContext from './contexts';
import { IconContext } from 'react-icons';
import './App.scss';
import { AccountStateProvider } from './contexts';

import * as Components from './components';

const withCustomAuthenticator = Comp => {
	return class extends Component {
		constructor(props) {
			super(props)
			this.state = {}
		}

		async componentDidMount() {
			//  this.setState({ token: async () => (await Auth.currentSession()).getAccessToken().getJwtToken() });
		}

		render() {
			const { authData } = this.props;
			return (
				<Authenticator hide={[SignIn, Greetings, ForgotPassword, SignUp]}>
					<Components.Authentication.CustomAuth />
					<Comp />
				</Authenticator>
			)
		}
	}
}


  
const App = (props) => {
	const { authState } = props;

	return (
		<div className="app">
			<IconContext.Provider value={{ className: 'global-class-name' }}>
				<CustomContext.ThemeProvider {...props}>
					<CustomContext.AlertsProvider {...props}>
						<CustomSwitch.Main />
						{/* {authState === 'signedIn' && (
							<AccountStateProvider {...props}>
								<CustomSwitch.Main />
							</AccountStateProvider>
						)} */}
					</CustomContext.AlertsProvider>
				</CustomContext.ThemeProvider>
			</IconContext.Provider>
		</div>
	);
};
export default App;
